import React from 'react';
import md from '../../markdown';

export default function General({ block }) {
  return (
    <div
      className="lesson-block"
      key={block.id}
      data-name={block.name}
      data-id={block.id}
      dangerouslySetInnerHTML={{ __html: md.makeHtml(block.content) }}
    />
  );
}
